/**
 * `ColumnDef` list for the Locations table: code link · name · type
 * (warehouse/datacenter) · address · active status. Built on the shared masters
 * status renderers + `TableLink`.
 */
import type { ColumnDef } from '@vnetwork/ui/data';
import type { WarehouseLocation } from '@/api/capacities';
import { TableLink } from '@/components/table-link';
import { activeStatusCell, locationTypeCell } from '../../shared/masters-status';

const muted = { color: 'var(--vn-fg-muted)', fontStyle: 'italic' } as const;

export const locationColumns: ColumnDef<WarehouseLocation, unknown>[] = [
  {
    id: 'code',
    header: 'Code',
    cell: ({ row }) => (
      <TableLink to={`/capacities/locations/${row.original.id}`} title={row.original.code}>
        {row.original.code || row.original.id}
      </TableLink>
    ),
  },
  {
    id: 'name',
    header: 'Location',
    cell: ({ row }) => (
      <span title={row.original.name} style={{ overflowWrap: 'anywhere' }}>
        {row.original.name}
      </span>
    ),
  },
  {
    id: 'type',
    header: 'Type',
    cell: ({ row }) => locationTypeCell(row.original.type),
  },
  {
    id: 'address',
    header: 'Address',
    cell: ({ row }) =>
      row.original.address ? (
        <span
          title={row.original.address}
          style={{ display: 'block', maxWidth: 360, overflowWrap: 'anywhere' }}
        >
          {row.original.address}
        </span>
      ) : (
        <span style={muted}>—</span>
      ),
  },
  {
    id: 'is_active',
    header: 'Status',
    cell: ({ row }) => activeStatusCell(row.original.is_active),
  },
];
